module.exports = __webpack_public_path__ + "static/img/banner_default_3.c628d4e3.png";